import React, {useEffect, useState, useRef} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {TscStyles} from '@techsmith/tsc-cloud-style-guide';
import {importMediaInterface} from '../../hooks/dynamicImport';
import {events} from '@techsmith/techsmith-smartplayer';

const CaptionDisplayStatusPlugin = styled.div`
   position: absolute;
   display: flex;
   align-items: center;
   top: .5rem;
   left: .5rem;
   height: 2rem;
   padding: .75rem!important;
   font-size: 1.5rem;
   background-color: rgba(0, 0, 0, 0.9);
   border-radius: ${TscStyles.border.radius.md};
`;

const displayTimeMilliseconds = 2500;

export const CaptionDisplayStatusPluginBase: React.FC = () => {
   const {t} = useTranslation();
   const [showMessage, setShowMessage] = useState(false);
   const messageTimeoutIdRef = useRef(-1);

   const displayCaptionStateMessage = () => {
      messageTimeoutIdRef.current !== -1 && clearTimeout(messageTimeoutIdRef.current);
      setShowMessage(true);
      messageTimeoutIdRef.current = window.setTimeout(() => {
         setShowMessage(false);
      }, displayTimeMilliseconds);
   };

   const onSmartPlayerCaptionsHidden = () => {
      messageTimeoutIdRef.current !== -1 && clearTimeout(messageTimeoutIdRef.current);
      messageTimeoutIdRef.current = -1;
      setShowMessage(false);
   };

   const onSmartPlayerCaptionsVisible = () => {
      displayCaptionStateMessage();
   };

   useEffect(() => {
      void importMediaInterface().then(mediaInterface => {
         mediaInterface.addEventListener(events.External.CaptionsHidden, onSmartPlayerCaptionsHidden);
         mediaInterface.addEventListener(events.External.CaptionsVisible, onSmartPlayerCaptionsVisible);
      });
      return () => {
         void importMediaInterface().then(mediaInterface => {
            mediaInterface.removeEventListener(events.External.CaptionsHidden, onSmartPlayerCaptionsHidden);
            mediaInterface.removeEventListener(events.External.CaptionsVisible, onSmartPlayerCaptionsVisible);
         });
      };
   }, []);

   return (
      showMessage && (
         <CaptionDisplayStatusPlugin className="caption-display-status-plugin">
            {t('smartPlayerPlugins.captionDisplayStatus.visibleAutoTranscribed')}
         </CaptionDisplayStatusPlugin>
      )
   );
};

export default CaptionDisplayStatusPluginBase;
